//== equal height elements

//== helper - set height on an element, accepting px number or string value
const setHeight = (el, val) => {
  if (typeof val === 'function') val = val();
  if (typeof val === 'string') el.style.height = val;
  else el.style.height = val + 'px';
};

//== equalise heights of elements within a selector, row by row
const equalheight = (container) => {
  let currentTallest = 0,
    currentRowStart = 0,
    rowDivs = [],
    topPosition = 0;

  Array.from(document.querySelectorAll(container)).forEach((el, i) => {
    el.style.height = 'auto';

    topPosition = Math.floor(el.getBoundingClientRect().top + window.scrollY);

    if (currentRowStart !== topPosition) {
      for (let currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
        setHeight(rowDivs[currentDiv], currentTallest);
      }
      rowDivs.length = 0;
      currentRowStart = topPosition;
      currentTallest = parseFloat(getComputedStyle(el, null).height.replace('px', ''));
      rowDivs.push(el);
    } else {
      rowDivs.push(el);
      currentTallest = currentTallest < parseFloat(getComputedStyle(el, null).height.replace('px', '')) ? parseFloat(getComputedStyle(el, null).height.replace('px', '')) : currentTallest;
    }
    for (let currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
      setHeight(rowDivs[currentDiv], currentTallest);
    }
  });
};

//== Apply equal heights to all configured selectors
export const applyEqualHeights = () => {
  equalheight('.eq');

  //== Run on viewports larger than small only
  if (window.innerWidth >= 640) {
    equalheight('.card .content .body');
    equalheight('.card .content');
  }
};

//== Simple debounce helper
//== Wait until the user stops resizing for 150ms, then run once
const debounce = (fn, delay) => {
  let timeout;
  return () => {
    clearTimeout(timeout);
    timeout = setTimeout(fn, delay);
  };
};

// window.addEventListener('load', applyEqualHeights)
window.addEventListener('pageshow', applyEqualHeights);
window.addEventListener('resize', debounce(applyEqualHeights, 150));
